export default __webpack_public_path__ + "static/media/complimentary@2x.a7f0850f.svg";